import React, { useState, useEffect } from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Collections } from 'app-constants';
import { getCollection } from 'utils';
import { EditMediaCard } from 'components';
import { Grid } from '@material-ui/core';
// import { gallery as mockGallery } from '../../mocks/gallery';

const useStyles = makeStyles((theme) => createStyles({
    root: {
      padding: theme.spacing(0.5),
      flexGrow: 1,
      backgroundColor: theme.palette.background.default
    },
    toolbar: theme.mixins.toolbar,
    card: { textAlign: 'center' }
  }));

function EditGallery() {
  const classes = useStyles();
  const [currentImage, setCurrentImage] = useState(0);

  const [gallery, setGallery] = useState([]);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  useEffect(() => {
    const unsubscribe = getCollection(Collections.GALLERY).onSnapshot((data) => {
      const galleryData = data.docs.map((doc) => {
        const obj = { ...doc.data() };
        obj.id = doc.id;
        return obj;
      });
      setGallery(galleryData);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.toolbar} />
      <br />
      {gallery.length ? (
        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={gallery.map((x) => ({
                  ...x.image,
                  srcset: x.srcSet,
                  caption: x.title
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      ) : null}
      <div className={classes.root}>
        <Grid alignItems="center" justify="center" container spacing={2}>
          {gallery.map((photo, index) => (
            <Grid key={photo.id} item xs={'auto'}>
              <EditMediaCard index={index} handleOpenCarousel={openLightbox} data={photo} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

export default EditGallery;
